// src/views/Employees/Modal/EmployeeModal.jsx
import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { modeConstants } from "../constants";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import { userActions } from "../redux/actions";

const DEFAULT_VALUES = {
  alert_days_before: "",
};

export default function NotificationModal({
  show,
  onHide,
  mode, // "add" | "edit" | "view"
}) {
  const isAdd = mode === modeConstants.ADD_MODE;
  const isEdit = mode === modeConstants.UPDATE_MODE;
  const isView = mode === modeConstants.VIEW_MODE;
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: { defaultValues: DEFAULT_VALUES },
  });

  const initialData = useSelector((s) => s.userReducer.notificationFormData);
  // load initial data in edit/view
  useEffect(() => {
    if (!show) return;

    if (isAdd) {
      reset(DEFAULT_VALUES);
      return;
    }

    if (initialData && (isEdit || isView)) {
      reset({
        alert_days_before: initialData.alert_days_before ?? "",
        email: initialData.email ?? "",
      });
    }
  }, [show, isAdd, isEdit, isView, initialData, reset]);

  const onSubmit = async (values) => {
    const fd = {"alert_days_before": values.alert_days_before,"id": initialData?.id };
    // choose endpoint
    if (isEdit && initialData?.id) {
      dispatch(userActions.updateNotification(fd, initialData?.id));
    }
    onHide && onHide();
  };

  const title = isAdd
    ? "Add Notification Setting"
    : isEdit
    ? "Edit Notification Setting"
    : "View Notification Setting";

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset disabled={isView}>
            <div className="row g-3">
              {/* LEFT SIDE: all text/date fields */}
              <div className="col-lg-8 pe-lg-5">
                <div className="row g-3">
                  {/* name + email */}
                  <div className="col-md-6">
                    <div className="form-floating">
                      <input
                        id="alert_days_before"
                        className="form-control"
                        {...register("alert_days_before", {
                          required: "Full name is required",
                        })}
                      />
                      <label htmlFor="alert_days_before">Alert Days Before</label>
                    </div>
                    {errors.alert_days_before && (
                      <small className="text-danger">
                        {errors.alert_days_before.message}
                      </small>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          {/* footer */}
          <div className="d-flex justify-content-end footer-modal">
            <Button
              variant="outline-secondary"
              onClick={onHide}
              className="btn-footer"
            >
              {isView ? "Close" : "Cancel"}
            </Button>
            {!isView && (
              <Button type="submit" variant="success" className="btn-footer">
                {isEdit ? "Save Changes" : "Create User"}
              </Button>
            )}
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
